import { render, staticRenderFns } from "./ThumbsSlider.vue?vue&type=template&id=08bbc54b&"
import script from "./ThumbsSlider.vue?vue&type=script&lang=js&"
export * from "./ThumbsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports